<template>
  <div class="suList mt20">
    <div class="suList-item borderRadius white-bg" v-for="(item,index) in list" :key="index">
      <img class="transform-scale" :src="item.image" @click="$router.push({path: '/course'})"/>
      <div class="p20">
        <div class="title mb10 cl333 font-bold f18">{{ item.category_name }}</div>
        <div class="text flex al-cn cl999 f14">
          <img class="icon" src="@/assets/icon/video-circle.png"/>
          <span class="ml5">张量（理论和应用）_郭仲衡</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "su-list",
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.suList {
  display: grid;
  grid-column-gap: 30px;
  grid-template-columns: calc(33.33333% - 20px) calc(33.33333% - 20px) calc(33.33333% - 20px);

  &-item {
    margin-bottom: 30px;
    //溢出隐藏
    overflow: hidden;

    img {
      border-radius: 6px 6px 0 0;
      width: 100%;
      height: 198px;
    }

    .text {
      .icon {
        width: 15px;
        height: 15px;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .suList {
    grid-column-gap: 15px;
    grid-template-columns: calc(50% - 7px) calc(50% - 7px);

    &-item {
      margin-bottom: 15px;

      img {
        border-radius: 6px 6px 0 0;
        width: 100%;
        height: 120px;
      }
    }
  }
}
</style>
